import React from "react";
import { Typography } from "@mui/material";
import {
  StyledContainer,
  PageTitle,
  ContentSection,
  StyledList,
  InfoBox,
  textStyles,
} from "../../components/common/StyledComponents";

const PelerinajOltenia = () => {
  return (
    <StyledContainer>
      <PageTitle>Pelerinaj în Oltenia</PageTitle>

      <ContentSection title="Cuvânt de început">
        <Typography sx={{ ...textStyles.bold, color: "#2e7d32", mb: 2 }}>
          🌿„Stați pe căi și priviți, întrebați de cărările cele vechi, care
          este calea cea bună și mergeți pe ea, și veți găsi odihnă pentru
          sufletele voastre.” – Ieremia 6:16
        </Typography>
        <Typography sx={textStyles.regular}>
          ⚜️ Precum acest verset subliniază frumusețea regăsirii spirituale prin
          întoarcerea la rădăcinile credinței, la fel ne-o oferă și Oltenia prin
          liniștea mănăstirilor, simplitatea oamenilor și firescul credinței
          acestor locuri.
        </Typography>
        <Typography sx={textStyles.regular} mt={2}>
          ⚜️ Agenția Pelerinul Creștin, cu binecuvântarea Preasfințitului
          Părinte IUSTIN, organizează în perioada
          <strong> 5–7 septembrie 2025</strong>, un pelerinaj duhovnicesc în
          Oltenia – tărâm binecuvântat al României, cu rădăcini adânci în
          Ortodoxie și tradiția creștină.
        </Typography>
        <Typography sx={textStyles.regular} mt={2}>
          ⚜️ Aici au fost ctitorite unele dintre cele mai frumoase și sfinte
          așezăminte monahale, vetre de rugăciune, luminare și cultură.
        </Typography>
      </ContentSection>

      <ContentSection title="Popasuri Duhovnicești">
        <StyledList>
          <li>⛪ Mănăstirea Hurezi</li>
          <li>⛪ Mănăstirea Cozia</li>
          <li>⛪ Mănăstirea Polovragi și Peștera</li>
          <li>⛪ Mănăstirea Dintr-un Lemn</li>
          <li>⛪ Mănăstirea Govora</li>
          <li>⛪ Mănăstirea Arnota</li>
          <li>⛪ Mănăstirea Iezeru Vâlcea</li>
          <li>⛪ Mănăstirea Bistrița-Vâlcea</li>
          <li>⛪ Mănăstirea Sf. Filimon Golești Vâlcea</li>
        </StyledList>
        <Typography sx={{ ...textStyles.regular, mt: 2 }}>
          🌿 În Oltenia, credința este vie, transmisă din generație în
          generație, cu smerenie și iubire pentru Dumnezeu.
        </Typography>
      </ContentSection>

      <ContentSection title="Servicii Incluse">
        <StyledList>
          <li>✨ 2 nopți cazare</li>
          <li>✨ 1 masă/zi</li>
          <li>✨ Transport</li>
          <li>✨ Preot însoțitor și ghidaj religios</li>
          <li>✨ Alte bucurii duhovnicești</li>
        </StyledList>
      </ContentSection>

      <ContentSection title="Detalii și Înscriere">
        <InfoBox>
          <Typography sx={textStyles.regular}>⚜️ Tariful: 750 LEI</Typography>
          <Typography sx={textStyles.regular}>
            🙏 Grupul va fi însoțit de părintele consilier Valeriu Vana
          </Typography>
          <Typography sx={textStyles.regular}>
            📝 Informații și înscrieri la sediul agenției, Bd. Traian 1B, Baia
            Mare sau telefonic: 0755 182 802
          </Typography>
          <Typography sx={textStyles.regular}>
            📝 Confirmarea locului se face prin achitarea unui avans în maxim 5
            zile de la rezervare
          </Typography>
          <Typography sx={textStyles.regular}>
            📝 Locurile în autocar se atribuie în ordinea achitării avansului
          </Typography>
          <Typography sx={textStyles.regular}>
            📝 Pentru o bună desfășurare, grupul va fi format din minimum 30
            persoane
          </Typography>
        </InfoBox>
      </ContentSection>

      <Typography sx={{ ...textStyles.bold, mt: 4, textAlign: "center" }}>
        🌿 Vă așteptăm cu drag să descoperim împreună România creștină!
        <br />
        🌿 Slavă și mulțumire Domnului pentru toate!
      </Typography>
    </StyledContainer>
  );
};

export default PelerinajOltenia;
